import { configureStore, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ConnectionStatus } from './constants';
import { QuoteResponseWrapper } from './model/quoteResponseWrapper';
import { QuoteSubscribeRequestWrapper } from './model/quoteSubscribeRequestWrapper';

export const MARKETDATA_WS_STORE_NAME = `marketDataWs`;

export interface IMarketDataWsStore {
  connected: boolean;
  connectionStatus: ConnectionStatus;
  saveMessagesAndErrors: boolean;
  receivedMessages: any[];
  sentMessages: string[];
  errors: string[];
}

export const defaultMarketDataWsStore: IMarketDataWsStore = {
  connected: false,
  connectionStatus: ConnectionStatus.Disconnected,
  saveMessagesAndErrors: false,
  receivedMessages: [],
  sentMessages: [],
  errors: []
};

export const createMarketDataWsStore = (initialState: IMarketDataWsStore) =>
  createSlice({
    name: MARKETDATA_WS_STORE_NAME,
    initialState,
    reducers: {
      storeReset: () => defaultMarketDataWsStore,

      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      connect: (store, action: PayloadAction<{ wsUrl: string; origin?: string }>) => {
        // used to intiate the connection in the middleware
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      disconnect: (store) => {
        // used to close the connection in the middleware
      },
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      send: (store, action: PayloadAction<QuoteSubscribeRequestWrapper>) => {
        // used to send a message in the middleware
      },

      connectionStatusChanged: (store, action: PayloadAction<ConnectionStatus>) => {
        store.connectionStatus = action.payload;
        store.connected = action.payload === ConnectionStatus.Connected;
      },

      setSaveMessagesAndErrors: (store, action: PayloadAction<boolean>) => {
        store.saveMessagesAndErrors = action.payload;
      },

      quoteV1MessageReceived: (store, action: PayloadAction<QuoteResponseWrapper>) => {
        if (store.saveMessagesAndErrors) {
          store.receivedMessages.push(action.payload);
        }
      },

      unknownMessageReceived: (store, action: PayloadAction<any>) => {
        if (store.saveMessagesAndErrors) {
          store.receivedMessages.push(action.payload);
        }
      },

      messageSent: (store, action: PayloadAction<string>) => {
        if (store.saveMessagesAndErrors) {
          store.sentMessages.push(action.payload);
        }
      },

      errorReceived: (store, action: PayloadAction<string>) => {
        if (store.saveMessagesAndErrors) {
          store.errors.push(action.payload);
        }
      }
    }
  });

export const { actions, reducer } = createMarketDataWsStore(defaultMarketDataWsStore);

export const createStore = (initialStore: IMarketDataWsStore = defaultMarketDataWsStore) =>
  configureStore({ reducer: { [MARKETDATA_WS_STORE_NAME]: createMarketDataWsStore(initialStore).reducer } });

export const MarketDataWsStore = createStore();
export type IStore = ReturnType<typeof MarketDataWsStore.getState>;
